import React from 'react';
import { BrowseContainer } from '../containers/browse';
import { useCategoriesAndVideos } from '../hooks';

export default function Browse() {
  const { videos, loading, error } = useCategoriesAndVideos();

  return <BrowseContainer videos={videos} loading={loading} error={error} />;
}
